import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import type { SelectProps } from 'antd'
import { useGroupFee } from 'app/hooks/adminUsers/groupFee'
import { Meta, MetaTitle, MetaView } from './styles'
import { Text } from 'styles/reactnative'

const CreateClassificationSelect = ({ defaultValue, setSelectLevel }: any) => {
	const { data: list } = useGroupFee()
	const [options, setOptions] = useState<SelectProps['options']>([])
	const [dvalue, setValue] = useState<SelectProps['defaultValue']>({
		value: defaultValue,
		label: list?.filter((group: any) => group.level === defaultValue)[0]
			?.name,
	})
	useEffect(() => {
		if (list) {
			const newOptions = list?.map((group: any, index) => {
				if (group.level === defaultValue) {
					setSelectLevel(group.level)
					setValue({ value: group.level, label: group.name })
				}
				return {
					value: group.level,
					label: group.name,
				}
			})
			setOptions(newOptions)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [list, defaultValue])

	const handleChange = (value: string[], label) => {
		setSelectLevel(value)
		setValue(label)
	}
	return (
		<MetaView>
			<MetaTitle>
				<Text>회원구분</Text>
			</MetaTitle>
			<Meta
				style={{
					background: 'transparent',
					padding: 0,
				}}>
				<Select
					placeholder="회원구분"
					value={dvalue}
					onChange={handleChange}
					filterOption={true}
					options={options}
					style={{ width: '100%' }}
				/>
			</Meta>
		</MetaView>
	)
}

export default CreateClassificationSelect
